import { useNavigate } from 'react-router-dom';

export function IDAM() {
  const navigate = useNavigate();

  // List of platform data
  const platforms = [
    { name: 'YouTube Playlists', path: '/Cyber_IDAM_Yt', logo: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg' },
    { name: 'Coursera', path: '/Cyber_IDAM_Coursera', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU' },
    { name: 'Udemy Courses', path: '/Cyber_IDAM_Udemy', logo: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg' },
  ];

  return (
    <div>
      <h1>Links are below</h1>
      <p>
        These are the platforms for your <strong>IDAM</strong> study purpose. Explore and gain knowledge for educational purposes.
      </p>

      <h3>Recommended Platforms</h3>

      {/* Render platform sections dynamically */}
      {platforms.map(({ name, path, logo }) => (
        <div className="container_html_pg" key={path}>
          <img src={logo} alt={`${name} Logo`} style={{ height: '90px', width: '90px' }} />
          <h5>{name}</h5>
          <button className="btn_html_yt" onClick={() => navigate(path)}>Click Me</button>
        </div>
      ))}
    </div>
  );
}

export default IDAM;
